import { useCallback } from 'react'

import { useTranslation } from 'react-i18next'

import { ToastId, toaster } from '@enechain/ecloud-designsystem'

type ShowToastProps = {
  status?: 'success' | 'error'
  toastMessage?: string
  action?: () => void
}

type Props = {
  toastId: ToastId
  action?: () => void
}

type ReturnType = {
  showToast: ({ status, toastMessage }: ShowToastProps) => void
}

export function useSuccessToast({ toastId, action }: Props): ReturnType {
  const { t } = useTranslation(['component'])

  const showToast = useCallback(
    ({
      toastMessage = t('component:features.toast.reload'),
      action: showToastAction = action,
    }: ShowToastProps) => {
      toaster.create({
        id: String(toastId),
        type: 'success',
        title: toastMessage,
        closable: true,
        action:
          showToastAction != null
            ? {
                label: t('component:features.toast.action_ok'),
                onClick: showToastAction,
              }
            : undefined,
      })
    },
    [toastId, action, t],
  )

  return { showToast }
}

export function useErrorToast({ toastId, action }: Props): ReturnType {
  const { t } = useTranslation(['component'])

  const showToast = useCallback(
    ({
      toastMessage = t('component:features.toast.reload'),
      action: showToastAction = action,
    }: ShowToastProps) => {
      toaster.create({
        id: String(toastId),
        type: 'error',
        title: toastMessage,
        closable: true,
        action:
          showToastAction != null
            ? {
                label: t('component:features.toast.action_ok'),
                onClick: showToastAction,
              }
            : undefined,
      })
    },
    [toastId, action, t],
  )

  return { showToast }
}
